<!-- Risk Section -->
<section class="risk-section" id="about">
  <div class="container">
    <div class="risk-content">
      <div class="risk-text">
        <h2 class="risk-title">
          Looking at <span class="highlight">risk</span> differently​
        </h2>
        <p class="risk-description">
          HPS Life uniquely underwrites on a case-by-case basis using doctors. Clients with complex medical conditions
          do not always fit neatly into the boxes of typical underwriting manuals. By looking at cases through a
          clinical lens, we can offer terms where others cannot, and at competitive premiums.
        </p>

        <div class="risk-features">
          <div class="risk-feature">
            <div class="feature-icon-small">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#0075C9" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <span>This is evidenced by our record of offering terms in 90% of cases submitted.</span>
          </div>
        </div>
      </div>
      <div class="risk-visual">
        <div class="visual-container">
          <!-- Additional Cards Below Image -->
          <div class="additional-cards">
            <div class="info-card card-1 left-chat">
              <div class="card-header">
                <div class="card-icon">⚡</div>
                <h3>Fast Medical Evidence Collection</h3>
              </div>
              <p>Using our in-house team of registered nurses we can expedite the underwriting process by presenting
                evidence accurately and quickly.</p>
            </div>

            <div class="info-card card-2 right-chat">
              <div class="card-header">
                <div class="card-icon">💬</div>
                <h3>Real Time Case Management</h3>
              </div>
              <p>Providing advisors, insurers, underwriters, and customers with their own unique access to our HPS
                Life Portal, allows all parties to see live progress of cases and where necessary, follow up.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
